/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./app-aside.component";
var styles_AppAsideComponent = [];
var RenderType_AppAsideComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_AppAsideComponent, data: {} });
export { RenderType_AppAsideComponent as RenderType_AppAsideComponent };
export function View_AppAsideComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "aside", [["class", "aside-menu"]], null, null, null, null, null))], null, null); }
export function View_AppAsideComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "app-aside", [], null, null, null, View_AppAsideComponent_0, RenderType_AppAsideComponent)), i0.ɵdid(1, 49152, null, 0, i1.AppAsideComponent, [], null, null)], null, null); }
var AppAsideComponentNgFactory = i0.ɵccf("app-aside", i1.AppAsideComponent, View_AppAsideComponent_Host_0, {}, {}, []);
export { AppAsideComponentNgFactory as AppAsideComponentNgFactory };
